import resourceService from './resource_service';

const modelName = 'trend-report';

const attributes = {
  name: '',
  trends: {},
};

const relationships = {};

export default resourceService(modelName, attributes, relationships);
